export default __webpack_public_path__ + "static/media/heroImg.79117c07.jpg";